import { type CoachSessionOpportunity, type PostApplicationGoalSettingSessionOpportunity } from '../Coach.types';

export function isPostApplicationGoalSettingSessionOpportunity(
    opportunity: CoachSessionOpportunity | null | undefined,
): opportunity is PostApplicationGoalSettingSessionOpportunity {
    return opportunity?.sessionType === 'post_application_goal_setting';
}
